/* Search hub (sections/search-hub.liquid). Per-page script, loaded (deferred) by the section.
   Shows the clear button while the field has text, submits the sort select on change, opens/closes the filter
   panel on phones, and focuses an empty search field on wide screens. Everything else is server rendered. */
(function () {
  document.querySelectorAll('[data-search-hub]').forEach(function (root) {
    var input = root.querySelector('[data-sr-input]');
    var clear = root.querySelector('[data-sr-clear]');
    if (input && clear) {
      var sync = function () { clear.hidden = !input.value; };
      input.addEventListener('input', sync);
      clear.addEventListener('click', function () { input.value = ''; sync(); input.focus(); });
      sync();
      if (!input.value && window.matchMedia && window.matchMedia('(min-width: 990px) and (pointer: fine)').matches) input.focus();
    }
    var sort = root.querySelector('[data-sr-sort]');
    if (sort) sort.addEventListener('change', function () { sort.form.submit(); });
    var btn = root.querySelector('[data-sr-filters-btn]');
    var panel = root.querySelector('[data-sr-filters]');
    if (btn && panel) btn.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();
